var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlutenfree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "48.000000pt",
    height: "48.000000pt",
    viewBox: "0 0 48.000000 48.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,48.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153 463 c-52 -18 -125 -95 -141 -151 -28 -91 -8 -167 63 -237 101 -102 229 -102 330 0 98 97 101 222 8 325 -67 75 -162 98 -260 63z m204 -46 c90 -62 118 -183 67 -278 -38 -68 -90 -102 -168 -107 -130 -8 -226 81 -226 210 0 61 18 104 60 146 48 48 85 62 161 59 54 -2 74 -8 106 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 388 c-9 -12 -16 -30 -16 -40 0 -11 -7 -18 -19 -18 -18 0 -20 -7 -19 -92 1 -98 12 -128 50 -128 11 0 18 -7 18 -20 0 -11 5 -20 10 -20 6 0 10 9 10 20 0 13 7 20 20 20 34 0 47 38 48 133 0 79 -2 87 -19 87 -10 0 -19 7 -19 15 0 19 -29 65 -41 65 -4 0 -15 -10 -23 -22z m38 -24 c9 -23 -3 -56 -17 -51 -22 7 -21 67 2 67 5 0 12 -7 15 -16z m-34 -75 c7 -11 9 -24 5 -27 -9 -9 -40 13 -43 32 -5 23 25 20 38 -5z m80 8 c0 -17 -20 -37 -37 -37 -16 0 -17 22 -1 38 16 16 38 15 38 -1z m-76 -79 c5 -9 7 -20 3 -25 -11 -10 -41 11 -45 31 -5 23 26 18 42 -6z m76 7 c0 -12 -28 -35 -44 -35 -11 0 -6 26 6 38 17 17 38 15 38 -3z m-88 -62 c24 -22 23 -35 -4 -31 -15 2 -24 11 -26 26 -4 26 5 28 30 5z m88 4 c0 -17 -20 -37 -37 -37 -19 0 -16 27 5 39 23 14 32 13 32 -2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlutenfree);
export default __webpack_public_path__ + "static/media/glutenfree.ddd67bc1cb77856f16da2ffd6ac98b2d.svg";
export { ForwardRef as ReactComponent };